import { PermissionCodename } from "constants/permission";

const filterByPermissions = <T extends { permission?: PermissionCodename }>(
  items: T[],
  hasPermissionTo: (permission: PermissionCodename) => boolean
): T[] => {
  return items.filter(
    (item) =>
      !item.permission || hasPermissionTo(item.permission)
  );
};

export default filterByPermissions;
